<template>
  <Radar :data="chartData" :options="chartOptions" />
</template>

<script>
import { Radar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
} from 'chart.js'

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip)

const DIMENSION_LABELS = {
  'extraversion':        'Extraversiune',
  'agreeableness':       'Agreabilitate',
  'conscientiousness':   'Conștiinciozitate',
  'emotional-stability': ['Stabilitate', 'emoțională'],
  'openness':            'Deschidere',
}

// Fixed order for consistent radar shape across users
const DIMENSION_ORDER = [
  'extraversion',
  'agreeableness',
  'conscientiousness',
  'emotional-stability',
  'openness',
]

export default {
  name: 'TipiChart',
  components: { Radar },

  props: {
    dimensionScores: {
      type: Array,  // [{ dimension, score, level, rank }, …] from TIPI's toScore()
      required: true,
    },
  },

  computed: {
    // Flatten array into a lookup map for easy access by dimension key
    scoresMap() {
      return Object.fromEntries(this.dimensionScores.map(d => [d.dimension, d.score]))
    },

    chartData() {
      return {
        labels: DIMENSION_ORDER.map(d => DIMENSION_LABELS[d] ?? d),
        datasets: [{
          data: DIMENSION_ORDER.map(d => this.scoresMap[d] ?? null),
          backgroundColor: 'rgba(76, 175, 80, 0.2)',
          borderColor:     'rgba(56, 142, 60, 0.9)',
          pointBackgroundColor: 'rgba(56, 142, 60, 1)',
          pointRadius: 4,
          fill: true,
        }],
      }
    },

    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: ctx => ` ${ctx.parsed.r.toFixed(2)}`,
            },
          },
        },
        scales: {
          r: {
            min: 1,
            max: 7,
            ticks: {
              stepSize: 1,
              font: { size: 10 },
              backdropColor: 'transparent',
            },
            pointLabels: {
              font: { size: 12 },
            },
          },
        },
      }
    },
  },
}
</script>
